// EventsWidgets.js
import React from 'react';
import UpcomingEvents from '../../components/event/UpcomingEvents';
import DraftEvents from '../../components/event/DraftEvents';
import CreateEvent from '../../components/event/CreateEvent';

const EventsWidgets = () => {
  return (
    <div className="d-flex">
      <div className="p-4 flex-grow-1" style={{ background: '#fff', minHeight: '100vh' }}>
        <UpcomingEvents />
        <DraftEvents />
        <CreateEvent />
      </div>
    </div>
  );
};

export default EventsWidgets;
